"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignOrientation = exports.DetailLevel = exports.DetailCost = exports.DetailType = exports.AppEnvironments = exports.VelocityEventLogs = exports.StorageKeys = exports.IssuerStatuses = exports.DURATION_TYPES = exports.AdEventTypes = exports.EventActions = exports.VclRoutes = exports.ImsRoutes = exports.WalletRoutes = exports.EvidenceRoutes = exports.EventRoutes = exports.SignUpRoutes = exports.LinkedinRoutes = exports.SearchRoutes = exports.Routes = exports.getMemberLink = exports.getCredentialImageFromUrl = exports.nameChangeRequest = exports.generateQrWalletImg = exports.getCurationListById = exports.getUserForSEO = exports.getSingleContentById = void 0;
const ElementBaseConfig_1 = require("../config/ElementBaseConfig");
// This folder is used to store routes, enums etc.
// const mainAddress: string = "https://api-lb.appfurther.io";
// const mainAddress: string = "http://localhost:3001";
const mainAddress = () => (0, ElementBaseConfig_1.getElementkitConfig)().main_address;
const apiAddress = () => `${mainAddress()}/v1`;
const apiAddressV2 = () => `${mainAddress()}/v2`;
const apiAddressV3 = () => `${mainAddress()}/v3`;
const getSingleContentById = () => `${apiAddressV2()}/contentScraping/single`;
exports.getSingleContentById = getSingleContentById;
const getUserForSEO = () => `${apiAddressV2()}/users/getUserForSEO`;
exports.getUserForSEO = getUserForSEO;
const getCurationListById = () => `${apiAddressV2()}/curationList/getContainerAndContents/web`;
exports.getCurationListById = getCurationListById;
const generateQrWalletImg = () => `${apiAddressV3()}/certificate/downloadQRWalletImage`;
exports.generateQrWalletImg = generateQrWalletImg;
const nameChangeRequest = () => `${apiAddressV3()}/certificate/nameChangeRequest`;
exports.nameChangeRequest = nameChangeRequest;
const getCredentialImageFromUrl = () => `${apiAddressV3()}/certificate/getCredentialImageFromUrl`;
exports.getCredentialImageFromUrl = getCredentialImageFromUrl;
const getMemberLink = () => `${apiAddressV3()}/certificate/getMemberLink`;
exports.getMemberLink = getMemberLink;
// Search Routes
const getUserByUsername = () => `${apiAddressV2()}/users/getUserByUserNameAnon`;
const searchAnon = () => `${apiAddressV2()}/search/credential`;
const credentialPreview = () => `${apiAddressV2()}/search/credentialPreview`;
const getSingleUser = () => `${apiAddressV3()}/search/singleUser`;
const getCredentialsByEmail = () => `${apiAddressV3()}/search/getAllCertificatesAnonym`;
// Evidence Routes
const parseEvidences = () => `${apiAddressV3()}/certificate/parseEvidences`;
const parsePreviewEvidences = () => `${apiAddressV3()}/certificate/parsePreviewEvidences`;
const parseSupportingDocumentationLinks = () => `${apiAddressV3()}/certificate/parseSupportingDocumentationLinks`;
// Pdf Routes
const generatePdfLinkVerified = () => `${apiAddressV3()}/whitelabel/GeneratePDFLink`;
// IMS Routes
const ims = () => `${apiAddressV2()}/ims`;
const imsImage = () => `${ims()}/image`;
// Event Routes
const logActionEvent = () => `${apiAddressV3()}/users/logActionEventAnonym`;
const handleShare = () => `${apiAddress()}/certificates/shareEvent`;
const handleShareAnon = () => `${apiAddress()}/certificates/shareEventAnon`;
const createAdLog = () => `${apiAddressV3()}/marketing/log`;
// Verify
const verifyCredential = () => `${apiAddressV3()}/certificate/verifyCredential`;
//Collection
const getCollectionDetail = () => `${mainAddress()}/v3/collection/detailView`;
// Sign Up
const signUpWithGoogle = () => `${apiAddressV3()}/wallet/googleSignIn`;
const signUpWithLinkedin = () => `${apiAddressV3()}/wallet/linkedInSignIn`;
const signUpWithFacebook = () => `${apiAddressV3()}/wallet/facebookSignIn`;
const linkedInAccessToken = () => `${apiAddressV3()}/wallet/getLinkedInAccessToken`;
const signupLoginOtp = () => `${apiAddressV3()}/wallet/signupLoginOtp`;
// Wallet
const wallet = () => `${apiAddressV3()}/wallet`;
const getPathway = () => `${wallet()}/getPathway`;
const getCampaign = () => `${wallet()}/getCampaign`;
//Login
const login = () => `${wallet()}/login`;
// Sign Up
const signUp = () => `${wallet()}/signup`;
// Profile
const walletProfile = () => `${wallet()}/profile`;
const downloadTranscript = () => `${wallet()}/downloadTranscript`;
// Email Verification
const verifyEmail = () => `${wallet()}/verifyEmail`;
const resendEmailVerification = () => `${wallet()}/resendEmailVerificationNoRecaptcha`;
//Skill
const getSkillPage = () => `${wallet()}/getSkillPage`;
// Linkedin
const linkedinProxy = () => `${apiAddressV3()}/linkedinProxy`;
const sharePostLinkedin = () => `${apiAddressV3()}/sharePostLinkedin`;
// VCL
const vcl = () => `${apiAddressV3()}/vcl`;
const getDisclosures = () => `${vcl()}/disclosures`;
const getDisclosureById = () => `${vcl()}/getDisclosureById`;
const editDisclosure = () => `${vcl()}/editDisclosure`;
const deleteDisclosure = () => `${vcl()}/deleteDisclosure`;
const getIssuers = () => `${vcl()}/getIssuers`;
const getCredentials = () => `${vcl()}/getCredentials`;
const discloseIdentityCredentials = () => `${vcl()}/discloseIdentityCredentialsToIssuer`;
const claimOffers = () => `${vcl()}/claimOffers`;
const claimOffersFromDeeplink = () => `${vcl()}/claimOffersFromDeeplink`;
const createDisclosure = () => `${vcl()}/createDisclosure`;
const deleteCredential = () => `${vcl()}/deleteCredential`;
const getCredentialManifest = () => `${vcl()}/getCredentialManifest`;
const createContactDetail = () => `${vcl()}/createContactDetail`;
const verifyContactDetail = () => `${vcl()}/verifyContactDetail`;
const getDetails = () => `${vcl()}/getDetailsPage`;
const verifyDisclosure = () => `${vcl()}/verifyDisclosure`;
const verificationResultPdf = () => `${vcl()}/verificationResultPdf`;
const createActivityVelocityLog = () => `${vcl()}/createActivityVelocityLog`;
const getShareDisclosure = () => `${vcl()}/getShareDisclosure`;
const getTestnetPersonas = () => `${vcl()}/testnetPersonas`;
const switchToPersona = () => `${vcl()}/switchToPersona`;
const getOffersBy = () => `${vcl()}/getOffersBy`;
const quickClaim = () => `${vcl()}/quickClaim`;
// Issuer Profile
const getIssuer = () => `${apiAddressV3()}/issuer/get`;
const getCampaigns = () => `${apiAddressV3()}/issuer/getCampaigns`;
const getCollections = () => `${apiAddressV3()}/issuer/getCollections`;
const getRecipients = () => `${apiAddressV3()}/issuer/getRecipients`;
exports.Routes = Object.freeze({
    getSingleContentById: exports.getSingleContentById,
    getUserForSEO: exports.getUserForSEO,
    getCurationListById: exports.getCurationListById,
    generatePdfLinkVerified,
    generateQrWalletImg: exports.generateQrWalletImg,
    verifyCredential,
    getCollectionDetail,
    getSkillPage,
    nameChangeRequest: exports.nameChangeRequest,
    getCredentialImageFromUrl: exports.getCredentialImageFromUrl,
    getMemberLink: exports.getMemberLink,
});
exports.SearchRoutes = Object.freeze({
    getUserByUsername,
    getSingleUser,
    getCredentialsByEmail,
    searchAnon,
    credentialPreview,
    getPathway,
    getCampaign,
});
exports.LinkedinRoutes = Object.freeze({
    linkedinProxy,
    sharePostLinkedin,
});
exports.SignUpRoutes = Object.freeze({
    signUp,
    signUpWithGoogle,
    signUpWithLinkedin,
    signUpWithFacebook,
    linkedInAccessToken,
});
exports.EventRoutes = Object.freeze({
    logActionEvent,
    handleShare,
    handleShareAnon,
    createAdLog,
});
exports.EvidenceRoutes = Object.freeze({
    parseEvidences,
    parsePreviewEvidences,
    parseSupportingDocumentationLinks,
});
exports.WalletRoutes = Object.freeze({
    signupLoginOtp,
});
exports.ImsRoutes = Object.freeze({ ims, imsImage });
exports.VclRoutes = Object.freeze({
    getDisclosures,
    getDisclosureById,
    editDisclosure,
    deleteDisclosure,
    getIssuers,
    getCredentials,
    discloseIdentityCredentials,
    claimOffers,
    claimOffersFromDeeplink,
    createDisclosure,
    deleteCredential,
    getCredentialManifest,
    createContactDetail,
    verifyContactDetail,
    getDetails,
    verifyDisclosure,
    verificationResultPdf,
    createActivityVelocityLog,
    getShareDisclosure,
    getTestnetPersonas,
    switchToPersona,
    getOffersBy,
    quickClaim,
});
exports.EventActions = Object.freeze({
    ProfileView: 1,
    CredentialView: 2,
    ExperienceView: 3,
    EducationView: 4,
    Search: 5,
    VerifyCredential: 6,
    ContactIssuer: 7,
    SourcePageView: 8,
    SourceFollow: 9,
    ListPageView: 10,
    ListFollow: 11,
    ListContentEdit: 12,
    SkillFollow: 13,
    SkillPageView: 14,
    ProfileFollow: 15,
    NotificationClick: 16,
    ScreenView: 17,
    AppOpen: 18,
    IssuerContact: 19,
    IssuerWebsiteVisit: 20,
    LinkedinTrafficGain: 21,
    FacebookTrafficGain: 22,
    InstagramTrafficGain: 23,
    TwitterTrafficGain: 24, // From Verified.cv
});
exports.AdEventTypes = Object.freeze({
    click: 1,
    view: 2,
});
var DURATION_TYPES;
(function (DURATION_TYPES) {
    DURATION_TYPES[DURATION_TYPES["Hour"] = 1] = "Hour";
    DURATION_TYPES[DURATION_TYPES["Day"] = 2] = "Day";
    DURATION_TYPES[DURATION_TYPES["Week"] = 3] = "Week";
    DURATION_TYPES[DURATION_TYPES["Month"] = 4] = "Month";
    DURATION_TYPES[DURATION_TYPES["Year"] = 5] = "Year";
    DURATION_TYPES[DURATION_TYPES["Minute"] = 6] = "Minute";
})(DURATION_TYPES = exports.DURATION_TYPES || (exports.DURATION_TYPES = {}));
exports.IssuerStatuses = Object.freeze({
    0: "not-verified",
    1: "verified",
});
exports.StorageKeys = Object.freeze({
    user_token: "__tkn__",
    user_id: "__uid__",
    user: "__u__",
    usr_certificate_ids: "__CSID__",
    usr_badge_ids: "___BDID__",
    current_lang: "__cLang__",
    error_logs_to_send: "___errlg__",
    ads_log_id: "__adslg__",
    app_env: "__aenv__",
});
exports.VelocityEventLogs = Object.freeze({
    DisclosureVerify: 1,
    DisclosureDownloadPdf: 2,
    DisclosureShareTwitter: 3,
    DisclosureShareFacebook: 4,
    DisclosureShareXing: 5,
    DisclosureShareYammer: 6,
    DisclosureShareWhatsapp: 7,
    DisclosureShareLinkedin: 8,
    DisclosureSetLinkedinProfile: 9,
    CredentialDownloadPng: 10,
});
exports.AppEnvironments = Object.freeze({
    dev: 1,
    prod: 2,
    beta: 3,
});
var DetailType;
(function (DetailType) {
    DetailType[DetailType["FieldEvent"] = 0] = "FieldEvent";
    DetailType[DetailType["OnlineEvent"] = 1] = "OnlineEvent";
    DetailType[DetailType["ClassCourse"] = 2] = "ClassCourse";
    DetailType[DetailType["OnlineCourse"] = 3] = "OnlineCourse";
    DetailType[DetailType["Webinar"] = 4] = "Webinar";
    DetailType[DetailType["Achievement"] = 5] = "Achievement";
    DetailType[DetailType["License"] = 6] = "License";
    DetailType[DetailType["Appreciation"] = 7] = "Appreciation";
    DetailType[DetailType["PromotionalCourse"] = 8] = "PromotionalCourse";
    DetailType[DetailType["Membership"] = 9] = "Membership";
    DetailType[DetailType["Graduation"] = 10] = "Graduation";
    DetailType[DetailType["HybridEvent"] = 11] = "HybridEvent";
    DetailType[DetailType["HybridCourse"] = 12] = "HybridCourse";
    DetailType[DetailType["ApprenticeshipCompletion"] = 13] = "ApprenticeshipCompletion";
    DetailType[DetailType["AssociateDegree"] = 14] = "AssociateDegree";
    DetailType[DetailType["Award"] = 15] = "Award";
    DetailType[DetailType["BadgeOfExcellence"] = 16] = "BadgeOfExcellence";
    DetailType[DetailType["BachelorsDegree"] = 17] = "BachelorsDegree";
    DetailType[DetailType["CapstoneAchievement"] = 18] = "CapstoneAchievement";
    DetailType[DetailType["CertificateOfCompletion"] = 19] = "CertificateOfCompletion";
    DetailType[DetailType["CompetencyBasedAchievement"] = 20] = "CompetencyBasedAchievement";
    DetailType[DetailType["ConferenceParticipation"] = 21] = "ConferenceParticipation";
    DetailType[DetailType["CourseCompletion"] = 22] = "CourseCompletion";
    DetailType[DetailType["CreativeWork"] = 23] = "CreativeWork";
    DetailType[DetailType["CustomAchievement"] = 24] = "CustomAchievement";
    DetailType[DetailType["Diploma"] = 25] = "Diploma";
    DetailType[DetailType["DoctoralDegree"] = 26] = "DoctoralDegree";
    DetailType[DetailType["HackathonParticipation"] = 27] = "HackathonParticipation";
    DetailType[DetailType["InternshipCompletion"] = 28] = "InternshipCompletion";
    DetailType[DetailType["LeadershipAchievement"] = 29] = "LeadershipAchievement";
    DetailType[DetailType["LifelongLearningRecognition"] = 30] = "LifelongLearningRecognition";
    DetailType[DetailType["MastersDegree"] = 31] = "MastersDegree";
    DetailType[DetailType["MicroCredential"] = 32] = "MicroCredential";
    DetailType[DetailType["PostgraduateCertificate"] = 33] = "PostgraduateCertificate";
    DetailType[DetailType["PostgraduateDiploma"] = 34] = "PostgraduateDiploma";
    DetailType[DetailType["ProfessionalCertification"] = 35] = "ProfessionalCertification";
    DetailType[DetailType["ProjectCompletion"] = 36] = "ProjectCompletion";
    DetailType[DetailType["ResearchContribution"] = 37] = "ResearchContribution";
    DetailType[DetailType["SkillMastery"] = 38] = "SkillMastery";
    DetailType[DetailType["TeachingExperience"] = 39] = "TeachingExperience";
    DetailType[DetailType["TechnicalCertification"] = 40] = "TechnicalCertification";
    DetailType[DetailType["VolunteerExperience"] = 41] = "VolunteerExperience";
    DetailType[DetailType["NA"] = 42] = "NA";
    DetailType[DetailType["Course"] = 43] = "Course";
    DetailType[DetailType["Workshop"] = 44] = "Workshop";
})(DetailType = exports.DetailType || (exports.DetailType = {}));
var DetailCost;
(function (DetailCost) {
    DetailCost[DetailCost["Free"] = 0] = "Free";
    DetailCost[DetailCost["Paid"] = 1] = "Paid";
    DetailCost[DetailCost["NA"] = 2] = "NA";
})(DetailCost = exports.DetailCost || (exports.DetailCost = {}));
var DetailLevel;
(function (DetailLevel) {
    DetailLevel[DetailLevel["Beginner"] = 0] = "Beginner";
    DetailLevel[DetailLevel["Intermediate"] = 1] = "Intermediate";
    DetailLevel[DetailLevel["Advanced"] = 2] = "Advanced";
    DetailLevel[DetailLevel["Experienced"] = 3] = "Experienced";
    DetailLevel[DetailLevel["Professional"] = 4] = "Professional";
    DetailLevel[DetailLevel["NA"] = 5] = "NA";
})(DetailLevel = exports.DetailLevel || (exports.DetailLevel = {}));
var DesignOrientation;
(function (DesignOrientation) {
    DesignOrientation[DesignOrientation["Landscape"] = 1] = "Landscape";
    DesignOrientation[DesignOrientation["Portrait"] = 2] = "Portrait";
    DesignOrientation[DesignOrientation["LetterLandscape"] = 3] = "LetterLandscape";
    DesignOrientation[DesignOrientation["LetterPortrait"] = 4] = "LetterPortrait";
    DesignOrientation[DesignOrientation["Ratio16_9"] = 5] = "Ratio16_9";
    DesignOrientation[DesignOrientation["LegalSizeLandscape"] = 6] = "LegalSizeLandscape";
    DesignOrientation[DesignOrientation["LegalSizePortrait"] = 7] = "LegalSizePortrait";
})(DesignOrientation = exports.DesignOrientation || (exports.DesignOrientation = {}));
